<template>  
  <v-container grid-list-lg fluid class="ma-0 pa-0">
    <v-layout row>
      <v-flex xs12 md4>
        <form @submit.prevent="onsubmit">
        <v-card>                    
          <v-card-text>           
            <template v-if="isUpdate">
              <v-list>
                <v-list-item class="px-0">
                  <v-list-item-avatar color="cyan">
                    <v-icon dark>face</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{fm.username}}</v-list-item-title>
                    <v-list-item-subtitle>{{fm.email}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </template>

            <template >
              <v-text-field
              label="Username"
              v-model="fm.username"
              prepend-icon="person"
              type="text"
              :error="!!error.username.length"
              :error-messages="error.username"
              ></v-text-field>

              <v-text-field
              label="Email"
              v-model="fm.email"
              prepend-icon="email"
              type="email"
              :error="!!error.email.length"
              :error-messages="error.email"
              ></v-text-field>
             
            </template>
            
             <v-text-field
              label="Phone"
              v-model="fm.phone"
              prepend-icon="phone"
              type="text"
              :error="!!error.phone.length"
              :error-messages="error.phone"
              ></v-text-field>

            <v-text-field
              id="password"
              label="Password"
              v-model="fm.password"
              prepend-icon="lock"              
              :error="!!error.password.length"
              :error-messages="error.password"
              :append-icon="showPass ? 'visibility' : 'visibility_off'"                    
              :type="showPass ? 'text' : 'password'"
              @click:append="showPass = !showPass"
            ></v-text-field>

            <!--<v-text-field v-if="isUpdate"
              id="password"
              label="Retype Password"
              v-model="fm.retype_password"
              prepend-icon="lock"
              type="password"
              :error="!!error.retype_password.length"
              :error-messages="error.retype_password"
            ></v-text-field>-->

            <!--<v-text-field v-else
              id="password"
              label="Retype Password"
              v-model="fm.retypePassword"
              prepend-icon="lock"
              type="password"
              :error="!!error.retypePassword.length"
              :error-messages="error.retypePassword"
            ></v-text-field>-->
            <v-switch v-model="fm.status" :label="fm.status ? 'status active':'status inactive'" :true-value="10" :false-value="0" />

            <v-text-field
              label="Fullname"
              v-model="fm.name"
              prepend-icon="person"
              type="text"
              :error="!!error.name.length"
              :error-messages="error.name"
              ></v-text-field>

             <v-text-field
              label="trial"
              v-model="fm.trialtime"
              prepend-icon="timer"
              type="datetime-local"
              :error="!!error.trialtime.length"
              :error-messages="error.trialtime"
              ></v-text-field> 
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn type="submit" :color="isUpdate?'blue':'green'" :loading="loading" dark>{{isUpdate?'update':'create'}}</v-btn>
          </v-card-actions>
        </v-card>
        </form>   
      </v-flex>
      <v-flex xs12 md8>                      
        <assignment v-if="showAssignment" class="mb-3" />        
        <node-assignment v-if="showAssignment" class="mb-3" />        
      </v-flex>    
      <v-flex xs12>
        <jilid-assignment v-if="showAssignment" :assignment="[]" class="mb-3" />
      </v-flex>      
    </v-layout>
  </v-container>    
</template>

<script>
import Assignment   from './assignment'
import NodeAssignment   from './node-assignment'
import JilidAssignment  from './jilid-assignment'
import Model from '@/app/models/Admin'
const  model = new Model();

export default {
  components:{Assignment, NodeAssignment, JilidAssignment},
  data : () => ({  
    fm:{username: null, email:null, phone:null, password:null, status:10, name:null,trialtime:null,/*retype_password: null, retypePassword: null*/},
    error:{username : [], email : [], phone : [], password : [], status:[], name:[], trialtime:[],/*retype_password:[], retypePassword:[]*/ },
    loading: false,
    isUpdate: false,
    term: null,
    mode: 0,   
    showPass: false 
  }),
  computed: {
    showAssignment(){
      return this.$route.query.id !== undefined;
    }    
  },
  mounted(){
    if(this.$route.query.id){
      this.isUpdate = true;
      model.view({id:this.$route.query.id}).then(data=>{
        Object.assign(this.fm, data);
      })
    }
  },
  methods: {
    onsubmit(){
      this.loading = true;  this.clearErrors();
      if(this.isUpdate){        
        model.update(this.fm, {id:this.fm.id}).then(res=>{this.responseSubmit(res)})
      } else {        
        model.create(this.fm).then(res=>{this.responseSubmit(res, true)})
      }
    },

    responseSubmit(res, insert=false){
      console.log(this.fm.trialtime);
      this.loading = false;
      if(res.status === 200){
        window.getApp.$emit('showSnackbar', {text :'Data has been saved successfully', color: 'green', show:true});            
        if(insert){
          this.isUpdate = true;
          this.fm.id = res.data.id;
          this.$router.replace({name:'admin/users/form', query:{id:res.data.id}})
        } else {
          this.$router.push({name:'admin/users'})
        }        
      } else {
        this.validate(res.data);
      }
    },

    validate(data){      
      for(var i in data){        
        if(Array.isArray(this.error[data[i]['field']])){          
          this.error[data[i]['field']].push(data[i]['message']);
        }        
      }
    },

    clearErrors(){
      this.error.username = this.fm.username ? [] : ['Username is required']
      this.error.email = this.fm.email ? [] : ['Email is required']
      if(!this.isUpdate){
        this.error.password = this.fm.password ? [] : ['Password is required']
      }
      //this.error.retype_password = [];
      //this.error.retypePassword  = [];      
    }
  },
}
</script>

<style>
.ramping td, .ramping th {
    padding: 0 5px;
}
</style>